"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.INITIAL_STATE = exports.deltaMiddleware = void 0;

var _reduxActions = require("redux-actions");

var _constants = require("../constants");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var filterActions = [_constants.COMMENTS_FILTER_CLEAR, _constants.COMMENTS_FILTER_TIME, _constants.COMMENTS_FILTER_USERS, _constants.COMMENTS_TOGGLE_RESOLVED];
/**
 * Builds object of {id: comment} for performant lookup.
 * @param {array} comments - array of comments
 * @returns {bool} - object of comments keyed by id.
 */

function mapCommentsById(comments) {
  var commentMap = {};
  comments.forEach(function (comment) {
    commentMap[comment.id] = comment;
  });
  return commentMap;
}
/**
 * Gets complement of two arrays by id.
 * @param {array} listA - array of comments
 * @param {array} listB - array of comments
 * @returns {bool} - array of comments in a but not b
 */


function getComplementById(listA, listB) {
  var aIds = listA.map(function (_ref) {
    var id = _ref.id;
    return id;
  });
  return listB.filter(function (_ref2) {
    var id = _ref2.id;
    return !aIds.includes(id);
  });
}
/**
 * Finds any comments in commentsAfter that have a different etag than in commentsBefore.
 * @param {array} commentsBefore - array of comments
 * @param {array} commentsAfter - array of comments
 * @returns {bool} - array of comments with modified etags
 */


function getModifiedComments(commentsBefore, commentsAfter) {
  var beforeById = mapCommentsById(commentsBefore);
  return commentsAfter.filter(function (commentAfter) {
    var commentBefore = beforeById[commentAfter.id];
    return commentBefore && commentBefore.etag !== commentAfter.etag;
  });
}
/**
 * Determines if comments have changed between actions.
 * @param {array} commentsBefore - array of comments before the action
 * @param {array} commentsAfter - array of comments after the action
 * @returns {bool} - boolean for change
 */


function haveCommentsChanged(commentsBefore, commentsAfter) {
  return (// do a memory comparison before stringify to help speed up some operations
    // we dont want to stringify these objects for every action.
    commentsBefore !== commentsAfter && JSON.stringify(commentsBefore) !== JSON.stringify(commentsAfter) && // not sure this check is needed since we stringify
    !(commentsBefore.length === 0 && commentsAfter.length === 0)
  );
}
/**
 * Determines if filter has changed between actions.
 * @param {array} action - redux action
 * @returns {bool} - boolean for change
 */


function hasFilterChanged(action) {
  return filterActions.includes(action.type);
}
/**
 * Delta middleware calculate changes in comments.
 * There is no return from this function, but if a delta is found, it will dispatch an action.
 * @param {*} store - redux store object
 * @param {*} next - callback to trigger action we are intercepting
 * @param {*} action - action that is being intercepted
 * @returns {undefined}
 */


var deltaMiddleware = function deltaMiddleware(store) {
  return function (next) {
    return function (action) {
      var deltaAction = {
        type: _constants.DELTA_UPDATE,
        data: {
          new: [],
          deleted: [],
          modified: []
        },
        lastRequestAssetId: action.assetId
      };
      var commentsBefore = store.getState()["".concat(_constants.PREFIX, ":comments")].comments;
      next(action);
      var commentsAfter = store.getState()["".concat(_constants.PREFIX, ":comments")].comments;

      if (haveCommentsChanged(commentsBefore, commentsAfter)) {
        // It would be nice to separate polling updates from comments_get but that only removes the poll check.
        if (action.type === _constants.COMMENTS_GET.SUCCESS && !action.isPollUpdate) {
          deltaAction.reason = 'initialization';
          deltaAction.data.new = commentsAfter;
        } else {
          deltaAction.data.new = getComplementById(commentsBefore, commentsAfter);
          deltaAction.data.deleted = getComplementById(commentsAfter, commentsBefore);
          deltaAction.data.modified = getModifiedComments(commentsBefore, commentsAfter); // only attach reason if there were any changes found

          if (deltaAction.data.new.length || deltaAction.data.deleted.length || deltaAction.data.modified.length) {
            deltaAction.reason = 'update';
          }
        }
      }

      if (hasFilterChanged(action)) {
        deltaAction.reason = 'filter';
      }

      if (deltaAction.reason) {
        store.dispatch(deltaAction);
      }
    };
  };
};

exports.deltaMiddleware = deltaMiddleware;
var INITIAL_STATE = {
  reason: undefined,
  data: {}
};
/**
 * Reducer to handle updated delta
 * @param {object} state - current state of store
 * @param {object} action - action sent to the reducer
 * @returns {undefined}
 */

exports.INITIAL_STATE = INITIAL_STATE;

var deltaUpdate = function deltaUpdate(state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    reason: action.reason,
    data: action.data,
    lastRequestAssetId: action.lastRequestAssetId
  });
};

var _default = (0, _reduxActions.handleActions)(_defineProperty({}, _constants.DELTA_UPDATE, deltaUpdate), INITIAL_STATE);

exports.default = _default;